// import { useEffect, useState } from "react";
// import { PencilIcon } from "@heroicons/react/outline";
// import EditMainInfoModal from "./EditMainInfoModal";
// import "react-quill-new/dist/quill.snow.css";
// import ReactQuill from "react-quill-new";

// const InfoRow = ({ label, value, children }) => (
//   <div className="mb-2">
//     <p className="text-slate-400">{label}</p>
//     {children ? children : <p className="text-white">{value || "-"}</p>}
//   </div>
// );

// const InfoLinkRow = ({ label, value }) => (
//   <div className="mb-2">
//     <p className="text-slate-400">{label}</p>

//     {value ? (
//       <a
//         href={value}
//         target="_blank"
//         rel="noopener noreferrer"
//         className="text-pink-500 hover:underline break-all"
//       >
//         {value}
//       </a>
//     ) : (
//       <p className="text-white">-</p>
//     )}
//   </div>
// );

// const MainInfoTab = ({ data, onUpdateMain, onUpdateDescription, loading }) => {
//   const [showMainModal, setShowMainModal] = useState(false);
//   const [showDescModal, setShowDescModal] = useState(false);

//   const [isEditingDesc, setIsEditingDesc] = useState(false);
//   const [descValue, setDescValue] = useState("");

//   const formatDate = (dateStr) => {
//     if (!dateStr) return "-";
//     return new Date(dateStr).toLocaleString();
//   };

//   const formatAddress = (address) => {
//     if (!address) return "-";

//     const parts = [
//       address.address_1,
//       address.address_2,
//       address.address_3,
//       address.city,
//       address.county,
//       address.country,
//       address.postcode,
//     ];

//     const filtered = parts.filter((p) => p && p.trim() !== "");

//     return filtered.length ? filtered.join(", ") : "-";
//   };

//   useEffect(() => {
//     setDescValue(data?.description || "");
//   }, [data]);

//   const formatArray = (arr) => (arr?.length ? arr.join(", ") : "-");

//   return (
//     <div className="grid grid-cols-2 gap-4">
//       {/* LEFT */}
//       <div className="bg-[#131C31] border border-white/10 rounded-lg p-4 relative">
//         <button
//           onClick={() => setShowMainModal(true)}
//           className="absolute top-3 right-3 text-slate-400 hover:text-white"
//         >
//           <PencilIcon className="w-4 h-4" />
//         </button>

//         <InfoRow label="Event Name" value={data?.name} />
//         <InfoLinkRow label="Link" value={data?.public_page_url} />
//         <InfoRow
//           label="Channels"
//           value={formatArray(data?.distribution_channels)}
//         />
//         <InfoRow label="Categories" value={data?.category} />

//         <InfoRow label="Venue" value={data?.map_address} />

//         <InfoRow label="Start" value={formatDate(data?.date_start)} />
//         <InfoRow label="End" value={formatDate(data?.date_end)} />

//         <InfoRow
//           label="Event Specific Type"
//           value={data?.event_specific_type}
//         />

//         <InfoRow label="Dress Code" value={data?.dress_code} />

//         <InfoRow label="Categories" value={data?.category} />

//         <div className="mt-2 mb-2">
//           <p className="text-slate-400 mb-1">Artist Lineup</p>

//           {data?.event_artists?.length > 0 ? (
//             <div className="flex flex-wrap gap-3">
//               {data.event_artists.map((artist) => (
//                 <div
//                   key={artist.id}
//                   className="flex items-center gap-2 bg-slate-800 border border-white/10 px-3 py-2 rounded-lg"
//                 >
//                   {/* IMAGE */}
//                   <img
//                     src={artist.profile_image}
//                     className="w-8 h-8 rounded-full object-cover"
//                   />

//                   {/* NAME */}
//                   <span className="text-sm text-white">{artist.name}</span>
//                 </div>
//               ))}
//             </div>
//           ) : (
//             <p className="text-sm text-slate-500">No Artists</p>
//           )}
//         </div>

//         {data?.client_commission_percentage !== 0 && (
//           <InfoRow
//             label="Platform Commission"
//             value={`${data?.client_commission_percentage}%`}
//           />
//         )}

//         <InfoRow
//           label="VAT included in commission"
//           value={data?.commission_vat_included ? "YES" : "NO"}
//         />

//         <InfoRow label="VAT" value={`${data?.commission_vat_percentage}%`} />

//         <InfoRow
//           label="Can buy without login"
//           value={data?.can_buy_without_login ? "YES" : "NO"}
//         />

//         <InfoRow label="Meta Tags" value={formatArray(data?.meta_tags)} />

//         <div className="mt-4">
//           <p className="text-slate-400 mb-1">Flyers</p>

//           <div className="grid grid-cols-2 gap-4">
//             {/* Horizontal Flyer */}
//             <div>
//               <p className="text-xs text-slate-400 mb-1">Horizontal</p>

//               {data?.flyer_horizontal ? (
//                 <a
//                   href={data.flyer_horizontal}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                 >
//                   <div className="relative group">
//                     <img
//                       src={data.flyer_horizontal}
//                       alt="Portrait Flyer"
//                       className="w-96 h-32 object-contain rounded-lg border border-white/10 hover:opacity-80 transition"
//                     />
//                   </div>
//                 </a>
//               ) : (
//                 <div className="w-57 h-32 flex items-center justify-center bg-slate-800 rounded-lg text-slate-500 text-xs">
//                   No Image
//                 </div>
//               )}
//             </div>

//             {/* Portrait Flyer */}
//             <div>
//               <p className="text-xs text-slate-400 mb-1">Portrait</p>

//               {data?.flyer_portrait ? (
//                 <a
//                   href={data.flyer_portrait}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                 >
//                   <img
//                     src={data.flyer_portrait}
//                     alt="Portrait Flyer"
//                     className="w-20 h-32 object-contain rounded-lg border border-white/10 hover:opacity-80 transition"
//                   />
//                 </a>
//               ) : (
//                 <div className="w-20 h-32 flex items-center justify-center bg-slate-800 rounded-lg text-slate-500 text-xs">
//                   No Image
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* RIGHT */}
//       {/* <div className="bg-[#131C31] border border-white/10 rounded-lg p-4 relative">
//         <button
//           onClick={() => setShowDescModal(true)}
//           className="absolute top-3 right-3 text-slate-400 hover:text-white"
//         >
//           <PencilIcon className="w-4 h-4" />
//         </button>

//         <p className="text-slate-400 mb-1">Description</p>

//         <div className="bg-white rounded-lg p-3">
//           <div
//             className="ql-editor"
//             dangerouslySetInnerHTML={{
//               __html: data?.description || "<p>No description</p>",
//             }}
//           />
//         </div>
//       </div> */}

//       <div className="bg-[#131C31] border border-white/10 rounded-lg p-4 relative">
//         <button
//           onClick={() => setIsEditingDesc((prev) => !prev)}
//           className="absolute top-3 right-3 text-slate-400 hover:text-white"
//         >
//           <PencilIcon className="w-4 h-4" />
//         </button>

//         <p className="text-slate-400 mb-2">Description</p>

//         {isEditingDesc ? (
//           <>
//             <div className="bg-[#131C31] rounded-lg overflow-hidden">
//               <ReactQuill
//                 theme="snow"
//                 value={descValue}
//                 onChange={setDescValue}
//                 modules={{
//                   toolbar: [
//                     [{ header: [2, 3, false] }],
//                     ["bold", "italic", "underline", "strike"],
//                     [{ align: [] }],
//                     ["link"],
//                     [{ list: "ordered" }, { list: "bullet" }],
//                     ["clean"],
//                   ],
//                 }}
//               />
//             </div>

//             {/* Actions */}
//             <div className="flex justify-end gap-3 mt-3">
//               <button
//                 onClick={() => {
//                   setIsEditingDesc(false);
//                   setDescValue(data?.description || "");
//                 }}
//                 className="px-3 py-1.5 text-sm text-slate-300 hover:bg-slate-800 rounded"
//               >
//                 Cancel
//               </button>

//               <button
//                 onClick={() => {
//                   onUpdateDescription(descValue);
//                   setIsEditingDesc(false);
//                 }}
//                 className="px-3 py-1.5 text-sm text-white bg-pink-600 hover:bg-pink-700 rounded"
//               >
//                 Save
//               </button>
//             </div>
//           </>
//         ) : (
//           <div className="bg-slate-800 rounded-lg p-3">
//             <div
//               className="ql-editor text-white"
//               dangerouslySetInnerHTML={{
//                 __html: data?.description || "<p>No description</p>",
//               }}
//             />
//           </div>
//         )}
//       </div>

//       <EditMainInfoModal
//         isOpen={showMainModal}
//         onClose={() => setShowMainModal(false)}
//         data={data}
//         onSubmit={onUpdateMain}
//       />

//       {/* {editImageType && (
//         <ImageUploadModal
//           type={editImageType}
//           onClose={() => setEditImageType(null)}
//           onSubmit={async (payload) => {
//             await onUpdateMain(payload); // or separate API
//             setEditImageType(null);
//           }}
//         />
//       )} */}

//       {/* <EditDescriptionModal
//         isOpen={showDescModal}
//         onClose={() => setShowDescModal(false)}
//         data={data}
//         onSubmit={onUpdateDescription}
//       /> */}
//     </div>
//   );
// };

// export default MainInfoTab;

import { useEffect, useState } from "react";
import { PencilIcon, XIcon, CheckIcon } from "@heroicons/react/outline";
import EditMainInfoModal from "./EditMainInfoModal";
import "react-quill-new/dist/quill.snow.css";
import ReactQuill from "react-quill-new";

const InfoRow = ({ label, value, children }) => (
  <div className="mb-2">
    <p className="text-slate-400">{label}</p>
    {children ? children : <p className="text-white">{value || "-"}</p>}
  </div>
);

const InfoLinkRow = ({ label, value }) => (
  <div className="mb-2">
    <p className="text-slate-400">{label}</p>
    {value ? (
      <a
        href={value}
        target="_blank"
        rel="noopener noreferrer"
        className="text-pink-500 hover:underline break-all"
      >
        {value}
      </a>
    ) : (
      <p className="text-white">-</p>
    )}
  </div>
);

const MainInfoTab = ({
  data,
  onUpdateMain,
  onUpdateDescription,
  onUpdateOrganiser,
  loading,
}) => {
  const [showMainModal, setShowMainModal] = useState(false);

  const [isEditingDesc, setIsEditingDesc] = useState(false);
  const [descValue, setDescValue] = useState("");

  const [isEditingOrganiser, setIsEditingOrganiser] = useState(false);
  const [organiserForm, setOrganiserForm] = useState({
    show_organiser_details: false,
    organiser_name: "",
    organiser_company_name: "",
    organiser_company_reg_no: "",
    organiser_vat_no: "",
    organiser_logo: "",
  });
  const [logoPreview, setLogoPreview] = useState("");

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    return new Date(dateStr).toLocaleString();
  };

  const formatAddress = (address) => {
    if (!address) return "-";
    const parts = [
      address.address_1,
      address.address_2,
      address.address_3,
      address.city,
      address.county,
      address.country,
      address.postcode,
    ];
    const filtered = parts.filter((p) => p && p.trim() !== "");
    return filtered.length ? filtered.join(", ") : "-";
  };

  useEffect(() => {
    setDescValue(data?.description || "");
    setOrganiserForm({
      show_organiser_details: data?.show_organiser_details || false,
      organiser_name: data?.organiser_name || "",
      organiser_company_name: data?.organiser_company_name || "",
      organiser_company_reg_no: data?.organiser_company_reg_no || "",
      organiser_vat_no: data?.organiser_vat_no || "",
      organiser_logo: data?.organiser_logo || "",
    });
    setLogoPreview(data?.organiser_logo || "");
  }, [data]);

  const formatArray = (arr) => (arr?.length ? arr.join(", ") : "-");

  const handleOrganiserChange = (key, value) => {
    setOrganiserForm((prev) => ({ ...prev, [key]: value }));
  };

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => {
      setLogoPreview(ev.target.result);
      setOrganiserForm((prev) => ({ ...prev, organiser_logo: file }));
    };
    reader.readAsDataURL(file);
  };

  const handleOrganiserCancel = () => {
    setIsEditingOrganiser(false);
    setOrganiserForm({
      show_organiser_details: data?.show_organiser_details || false,
      organiser_name: data?.organiser_name || "",
      organiser_company_name: data?.organiser_company_name || "",
      organiser_company_reg_no: data?.organiser_company_reg_no || "",
      organiser_vat_no: data?.organiser_vat_no || "",
      organiser_logo: data?.organiser_logo || "",
    });
    setLogoPreview(data?.organiser_logo || "");
  };

  const handleOrganiserSave = () => {
    onUpdateOrganiser(organiserForm);
    setIsEditingOrganiser(false);
  };

  return (
    <div className="grid grid-cols-2 gap-4">
      {/* LEFT */}
      <div className="bg-[#131C31] border border-white/10 rounded-lg p-4 relative">
        <button
          onClick={() => setShowMainModal(true)}
          className="absolute top-3 right-3 text-slate-400 hover:text-white"
        >
          <PencilIcon className="w-4 h-4" />
        </button>

        <InfoRow label="Event Name" value={data?.name} />
        <InfoLinkRow label="Link" value={data?.public_page_url} />
        <InfoRow
          label="Channels"
          value={formatArray(data?.distribution_channels)}
        />
        <InfoRow label="Categories" value={data?.category} />
        <InfoRow label="Venue" value={data?.map_address} />
        <InfoRow label="Start" value={formatDate(data?.date_start)} />
        <InfoRow label="End" value={formatDate(data?.date_end)} />
        <InfoRow
          label="Event Specific Type"
          value={data?.event_specific_type}
        />
        <InfoRow label="Dress Code" value={data?.dress_code} />
        <InfoRow label="Categories" value={data?.category} />

        <div className="mt-2 mb-2">
          <p className="text-slate-400 mb-1">Artist Lineup</p>
          {data?.event_artists?.length > 0 ? (
            <div className="flex flex-wrap gap-3">
              {data.event_artists.map((artist) => (
                <div
                  key={artist.id}
                  className="flex items-center gap-2 bg-slate-800 border border-white/10 px-3 py-2 rounded-lg"
                >
                  <img
                    src={artist.profile_image}
                    className="w-8 h-8 rounded-full object-cover"
                  />
                  <span className="text-sm text-white">{artist.name}</span>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-sm text-slate-500">No Artists</p>
          )}
        </div>

        {data?.client_commission_percentage !== 0 && (
          <InfoRow
            label="Platform Commission"
            value={`${data?.client_commission_percentage}%`}
          />
        )}
        <InfoRow
          label="VAT included in commission"
          value={data?.commission_vat_included ? "YES" : "NO"}
        />
        <InfoRow label="VAT" value={`${data?.commission_vat_percentage}%`} />

        <InfoRow label="Currency" value={`${data?.currency}`} />

        <InfoRow
          label="Can buy without login"
          value={data?.can_buy_without_login ? "YES" : "NO"}
        />
        
        <InfoRow label="Meta Tags" value={formatArray(data?.meta_tags)} />

        <div className="mt-4">
          <p className="text-slate-400 mb-1">Flyers</p>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <p className="text-xs text-slate-400 mb-1">Horizontal</p>
              {data?.flyer_horizontal ? (
                <a
                  href={data.flyer_horizontal}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="relative group">
                    <img
                      src={data.flyer_horizontal}
                      alt="Portrait Flyer"
                      className="w-96 h-32 object-contain rounded-lg border border-white/10 hover:opacity-80 transition"
                    />
                  </div>
                </a>
              ) : (
                <div className="w-57 h-32 flex items-center justify-center bg-slate-800 rounded-lg text-slate-500 text-xs">
                  No Image
                </div>
              )}
            </div>

            <div>
              <p className="text-xs text-slate-400 mb-1">Portrait</p>
              {data?.flyer_portrait ? (
                <a
                  href={data.flyer_portrait}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={data.flyer_portrait}
                    alt="Portrait Flyer"
                    className="w-20 h-32 object-contain rounded-lg border border-white/10 hover:opacity-80 transition"
                  />
                </a>
              ) : (
                <div className="w-20 h-32 flex items-center justify-center bg-slate-800 rounded-lg text-slate-500 text-xs">
                  No Image
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* RIGHT */}
      <div className="flex flex-col gap-4">
        {/* Description */}
        <div className="bg-[#131C31] border border-white/10 rounded-lg p-4 relative">
          <button
            onClick={() => setIsEditingDesc((prev) => !prev)}
            className="absolute top-3 right-3 text-slate-400 hover:text-white"
          >
            <PencilIcon className="w-4 h-4" />
          </button>

          <p className="text-slate-400 mb-2">Description</p>

          {isEditingDesc ? (
            <>
              <div className="bg-[#131C31] rounded-lg overflow-hidden">
                <ReactQuill
                  theme="snow"
                  value={descValue}
                  onChange={setDescValue}
                  modules={{
                    toolbar: [
                      [{ header: [2, 3, false] }],
                      ["bold", "italic", "underline", "strike"],
                      [{ align: [] }],
                      ["link"],
                      [{ list: "ordered" }, { list: "bullet" }],
                      ["clean"],
                    ],
                  }}
                />
              </div>
              <div className="flex justify-end gap-3 mt-3">
                <button
                  onClick={() => {
                    setIsEditingDesc(false);
                    setDescValue(data?.description || "");
                  }}
                  className="px-3 py-1.5 text-sm text-slate-300 hover:bg-slate-800 rounded"
                >
                  Cancel
                </button>
                <button
                  onClick={() => {
                    onUpdateDescription(descValue);
                    setIsEditingDesc(false);
                  }}
                  className="px-3 py-1.5 text-sm text-white bg-pink-600 hover:bg-pink-700 rounded"
                >
                  Save
                </button>
              </div>
            </>
          ) : (
            <div className="bg-slate-800 rounded-lg p-3">
              <div
                className="ql-editor text-white"
                dangerouslySetInnerHTML={{
                  __html: data?.description || "<p>No description</p>",
                }}
              />
            </div>
          )}
        </div>

        {/* Organiser Details */}
        <div className="bg-[#131C31] border border-white/10 rounded-lg p-4 relative">
          <button
            onClick={() =>
              isEditingOrganiser
                ? handleOrganiserCancel()
                : setIsEditingOrganiser(true)
            }
            className="absolute top-3 right-3 text-slate-400 hover:text-white"
          >
            <PencilIcon className="w-4 h-4" />
          </button>

          <p className="text-slate-400 mb-3">Organiser Details</p>

          {isEditingOrganiser ? (
            <>
              <div className="space-y-3">
                <div>
                  <label className="text-xs text-slate-400 mb-2 block">
                    Show organiser details on event page
                  </label>
                  <div className="flex items-center gap-6">
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input
                        type="radio"
                        name="show_organiser_details"
                        checked={organiserForm.show_organiser_details === true}
                        onChange={() =>
                          handleOrganiserChange("show_organiser_details", true)
                        }
                        className="accent-pink-500"
                      />
                      <span className="text-sm text-white">Yes</span>
                    </label>
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input
                        type="radio"
                        name="show_organiser_details"
                        checked={organiserForm.show_organiser_details === false}
                        onChange={() =>
                          handleOrganiserChange("show_organiser_details", false)
                        }
                        className="accent-pink-500"
                      />
                      <span className="text-sm text-white">No</span>
                    </label>
                  </div>
                </div>
                {/* Logo upload */}
                <div>
                  <p className="text-xs text-slate-400 mb-1.5">
                    Company Logo (500 x 500 Recommended)
                  </p>
                  <div className="flex items-center gap-4">
                    {logoPreview ? (
                      <img
                        src={logoPreview}
                        alt="Company logo"
                        className="w-14 h-14 rounded-lg object-contain border border-white/10 bg-slate-800"
                      />
                    ) : (
                      <div className="w-14 h-14 rounded-lg bg-slate-800 border border-white/10 flex items-center justify-center text-slate-500 text-xs">
                        No logo
                      </div>
                    )}
                    <label className="cursor-pointer px-3 py-1.5 text-sm text-slate-300 border border-white/10 rounded-lg hover:bg-slate-800 transition">
                      Upload
                      <input
                        type="file"
                        accept="image/*"
                        className="hidden"
                        onChange={handleLogoChange}
                      />
                    </label>
                  </div>
                </div>

                {/* Organiser Name */}
                <div>
                  <label className="text-xs text-slate-400 mb-1 block">
                    Organiser Name
                  </label>
                  <input
                    type="text"
                    value={organiserForm.organiser_name}
                    onChange={(e) =>
                      handleOrganiserChange("organiser_name", e.target.value)
                    }
                    className="w-full bg-slate-800 border border-white/10 rounded-lg px-3 py-2 text-sm text-white focus:outline-none focus:ring-2 focus:ring-pink-500/40"
                    placeholder="Organiser name"
                  />
                </div>

                {/* Company Name */}
                <div>
                  <label className="text-xs text-slate-400 mb-1 block">
                    Company Name
                  </label>
                  <input
                    type="text"
                    value={organiserForm.organiser_company_name}
                    onChange={(e) =>
                      handleOrganiserChange("organiser_company_name", e.target.value)
                    }
                    className="w-full bg-slate-800 border border-white/10 rounded-lg px-3 py-2 text-sm text-white focus:outline-none focus:ring-2 focus:ring-pink-500/40"
                    placeholder="Company name"
                  />
                </div>

                {/* Company Reg No */}
                <div>
                  <label className="text-xs text-slate-400 mb-1 block">
                    Company Reg No
                  </label>
                  <input
                    type="text"
                    value={organiserForm.organiser_company_reg_no}
                    onChange={(e) =>
                      handleOrganiserChange(
                        "organiser_company_reg_no",
                        e.target.value,
                      )
                    }
                    className="w-full bg-slate-800 border border-white/10 rounded-lg px-3 py-2 text-sm text-white focus:outline-none focus:ring-2 focus:ring-pink-500/40"
                    placeholder="e.g. 12345678"
                  />
                </div>

                {/* Company VAT No */}
                <div>
                  <label className="text-xs text-slate-400 mb-1 block">
                    Company VAT No
                  </label>
                  <input
                    type="text"
                    value={organiserForm.organiser_vat_no}
                    onChange={(e) =>
                      handleOrganiserChange(
                        "organiser_vat_no",
                        e.target.value,
                      )
                    }
                    className="w-full bg-slate-800 border border-white/10 rounded-lg px-3 py-2 text-sm text-white focus:outline-none focus:ring-2 focus:ring-pink-500/40"
                    placeholder="e.g. 12345678"
                  />
                </div>
              </div>

              <div className="flex justify-end gap-3 mt-4">
                <button
                  onClick={handleOrganiserCancel}
                  className="px-3 py-1.5 text-sm text-slate-300 hover:bg-slate-800 rounded"
                >
                  Cancel
                </button>
                <button
                  onClick={handleOrganiserSave}
                  className="px-3 py-1.5 text-sm text-white bg-pink-600 hover:bg-pink-700 rounded"
                >
                  Save
                </button>
              </div>
            </>
          ) : (
            <div className="space-y-3">
              <InfoRow
                label="Show on event page"
                value={data?.show_organiser_details ? "Yes" : "No"}
              />
              {/* Logo */}
              <div className="flex items-center gap-3">
                {data?.organiser_logo ? (
                  <img
                    src={data.organiser_logo}
                    alt="Company logo"
                    className="w-14 h-14 rounded-lg object-contain border border-white/10 bg-slate-800"
                  />
                ) : (
                  <div className="w-14 h-14 rounded-lg bg-slate-800 border border-white/10 flex items-center justify-center text-slate-500 text-xs">
                    No logo
                  </div>
                )}
              </div>

              <div className="border-t border-white/5 pt-3 space-y-2">
                <InfoRow label="Organizer Name" value={data?.organiser_name} />
                <InfoRow label="Company Name" value={data?.organiser_company_name} />
                <InfoRow
                  label="Company Reg No"
                  value={data?.organiser_company_reg_no}
                />
                <InfoRow
                  label="Company VAT No"
                  value={data?.organiser_vat_no}
                />
              </div>
            </div>
          )}
        </div>
      </div>

      <EditMainInfoModal
        isOpen={showMainModal}
        onClose={() => setShowMainModal(false)}
        data={data}
        onSubmit={onUpdateMain}
      />
    </div>
  );
};

export default MainInfoTab;
